import React from "react";
import PropTypes from "prop-types";
import { Script } from "gatsby";

const OneTrust = ({ otToken }) => {
  return (
    <>
    {'Dave'}
      <Script
        id="ot-sdk-script"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-domain-script={otToken}
      />
      <Script
        id="ot-sdk-script-func"
        dangerouslySetInnerHTML={{ __html: `function OptanonWrapper() { }` }}
      />
    </>
  );
};

export default OneTrust;

OneTrust.propTypes = {
  otToken: PropTypes.string.isRequired,
};

OneTrust.defaultProps = {
  otToken: "",
};
